import React from 'react';
import {
	Row,
	Col,
	Button,
	Table,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Input,
	Label,
	FormGroup,
	Form
} from 'reactstrap';

import { getMembershipUsers, DeleteMembershipUser, inviteMember, inviteMemberOnEdit,InviteManualUser} from '../../../../../Redux/Actions/EndUser/MemberInvitationAction';
import { auth } from '../../../../../services';
import { connect } from 'react-redux';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import ManualUserForm from '../../../../PublicView/Pages/MyMemberships/AuthorizedMembers/ModalForms/ManualUserForm';
import PortalUserForm from '../../../../PublicView/Pages/MyMemberships/AuthorizedMembers/ModalForms/PortalUserForm';
import InviteUserForm from '../../../../PublicView/Pages/MyMemberships/AuthorizedMembers/ModalForms/InviteUserForm';
import EditMembershipUserForm from '../../../../PublicView/Pages/MyMemberships/AuthorizedMembers/ModalForms/EditMembershipUserForm';
import { toastr,RemoveEmailMessage } from '../../../../../Redux/Actions/CommonActions';
import { Alert } from 'reactstrap';
import { withRouter } from 'react-router';
import '../../../../PublicView/Pages/MyMemberships/AuthorizedMembers/AuthorizedMembers.scss';

class AdditionalMembershipsForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			canInvite: false,
			emailMatches: false,
			modal: false,
			isNotManual: true,
			userModel:{},
			membershipId:this.props.dataItem.membershipId || 0,
			message:"",
			membershipCountMessage :"",
			membershipInEdit: this.props.dataItem || null,
			value: [],
			membershipUserInEdit: null,
			hideAuthBtns: false
		};
	}

    toggleModal = () => {
			this.props.cancel();

			this.setState((prevState) => ({
				canInvite: false,
				emailMatches: false
			}));
		this.props.RemoveEmailMessage();
		
	};

	componentDidMount() {
		console.log(this.state, "state in additional members");
		this.props.getMembershipUsers(this.state.membershipId);


		var membershipType = (this.props.dataItem.membershipType && this.props.dataItem.membershipType.description) ? this.props.dataItem.membershipType.description.toLowerCase() : '';

		var membershipPackage = (this.props.dataItem.membershipPackage && this.props.dataItem.membershipPackage.description) ? this.props.dataItem.membershipPackage.description : '';

		var flag = false;

		this.setState({
			hideAuthBtns: !(this.props.dataItem.additionalMemberships > 0)
		});

		//if (!membershipType || membershipType == 'allied' || membershipType == 'feedlots' || membershipType == 'student') {

		//	this.setState({
		//		hideAuthBtns: true
		//	});
		//} else if (membershipType == 'standard') {
		//	if (!membershipPackage) {
		//		this.props.toastr(true, 'Unable to get Standard Membership Package.', 'danger');
		//	}

		//	console.log(this.props.dataItem);
		//	var pkgHead = membershipPackage.match(/^(\D*)(\d+)/)[2];

		//	if (Number(pkgHead) < 251) {
		//		this.setState({
		//			hideAuthBtns: true
		//		});
		//	}
		//} else {
		//	if (this.state.hideAuthBtns) {
		//		this.setState({
		//			hideAuthBtns: false
		//		});
		//	}
  //      }

	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.emailMatches === false && this.props.common.emailMessage === 'This email matches an email associated with a user in the portal. This invitation will be sent to that user.') {
      this.setCanInvite();
		}
	}

	setCanInvite() {
		this.setState({
			canInvite: true,
			emailMatches: true
		})
	}

	portalUserStateChange = (userModel) => {
		this.props.common.emailMessage = '';
		this.setState({
				userModel: userModel,
				canInvite: false,
				emailMatches: false
		})
	}
	manualUserStateChange = (userModel) => {
		this.setState({
            userModel: userModel
        })
	}
	inviteUserStateChange = (userModel) => {
		this.setState({
            userModel: userModel
        })
	}
    handleSubmit = (event) => {
		event.preventDefault();
		this.setState({
			membershipCountMessage:""
		})
         
		const edited = this.state.userModel;
		edited.membershipId = this.state.membershipId;
		edited.memberSequenceNum = this.props.membershipUsers.length;
		edited.organizationName = this.state.membershipInEdit.organizationName;
	
		if(this.state.userModel.email ==="") {
			this.props.InviteManualUser(edited);
		} else if(!this.props.membershipUsers.includes(this.state.userModel.email)) {
			//(this.state.userModel.email !== this.props.details.userName)
		  this.props.inviteMember(edited);
        }
		else
		{
           this.setState({
			   message:"You are already part of this Organization"
		   })
        }

		this.setState((prevState) => ({
            modal: !prevState.modal,
            isNotManual: true
		}));
		this.props.common.emailMessage = "";
	};
	 
	Delete = (event) => {
		this.setState({
			membershipCountMessage:""
		})
		event.isActive = false;
		this.props.DeleteMembershipUser(event);
    };

	Activate = (event) => {
		this.setState({
			membershipCountMessage:""
		})
		var count = this.state.membershipInEdit.additionalMemberships - (this.props.membershipUsers.length-1) ;
		if(count > 0)
		{
			event.isActive = true;
			this.props.DeleteMembershipUser(event);
			
		}
		else
		{
			this.setState({
				membershipCountMessage:"You dont have memebership's available to activate user"
			})
		}
	};

	editUser = (memberNumber) => {
		let m = this.props.membershipUsers.filter(a => a.memberNumber == memberNumber)[0];
		this.setState({
			membershipUserInEdit: m
		});
	}

	returnFromEdit = () => {
		this.setState({
			membershipUserInEdit: null
		});
	}

	completeUpdatedInvite = (model) => {
		this.returnFromEdit();
		this.props.getMembershipUsers(this.state.membershipId);	
	}
	
	render() {
		if (this.props.getting)
			return (
				<div>
					<IsLoading />
				</div>
			);
			var membershipscount = this.state.membershipInEdit.additionalMemberships - (this.props.membershipUsers.length-1);
			console.log(membershipscount, "membershipscount in admin")
		return (
			<React.Fragment>
			{this.props.common.visible ? (
				<Alert
					color={this.props.common.color}
					isOpen={this.props.common.visible}
				>
					{this.props.common.message}
				</Alert>
			) : null}
			<div className="account-tab-content authorized-members">
				<div>
						{!this.state.membershipUserInEdit ?
							<div>
								{
									!this.state.hideAuthBtns ?
									<div>

										<h1 className="pt-3 pb-3"> Add Authorized Users</h1>
										<div className="account-tab-content-right">
											<div>
												<label className="info-text">
													You have <span className="highlight">{membershipscount > 0 ? membershipscount : 0}</span> of <span className="highlight">{this.state.membershipInEdit.additionalMemberships}</span> additional memberships available
												</label>
											</div>
										</div>
									</div>
									: ''
								}
								{
									!this.state.hideAuthBtns ?
										<Form onSubmit={this.handleSubmit}>
											<div className="">
												<div>
													<FormGroup check>
														<Row>
															<Col>
																<Input
																	type="radio"
																	name="radio1"
																	id="radio1"
																	defaultChecked
																	className="custom-control-input"
																	onClick={() => this.setState({ isNotManual: true })}
																/>{' '}
																<Label check htmlFor="radio1">
																	<span className={this.state.isNotManual === true ? "fas fa-check-circle" : "far fa-circle"}></span>
																	<span className="form-check-text">Member has an email address</span>
																</Label>
																<Input
																	type="radio"
																	name="radio2"
																	id="radio2"
																	className="custom-control-input"
																	onClick={() => {
																		this.props.RemoveEmailMessage();
																		this.setState({ isNotManual: false })
																	}}
																/>{' '}
																<Label check htmlFor="radio2">
																	<span className={this.state.isNotManual === false ? "fas fa-check-circle" : "far fa-circle"}></span>
																	<span className="form-check-text">Member does not have an email address</span>
																</Label>
															</Col>
														</Row>
													</FormGroup>
												</div>
												{/* {console.log(this.props.membershipUsers.some(user => user.isMembershipOwner === true),"isowner filter")} */}
												{/* {console.log(this.state.membershipInEdit.isMembershipOwner,"membershipInEdit membershipOwner")} */}
												{!this.state.isNotManual ? <ManualUserForm manualUserStateChange={this.manualUserStateChange} handleSubmit={this.handleSubmit} cancel={this.toggleModal} isOwner={this.props.membershipUsers.some(user => user.isMembershipOwner === true)} /> : <PortalUserForm portalUserStateChange={this.portalUserStateChange} message={this.state.message} />}
												{(this.props.common.emailMessage === "User does not exist. Please create the user.") ? <InviteUserForm handleSubmit={this.handleSubmit} cancel={this.toggleModal} inviteUserStateChange={this.inviteUserStateChange} isOwner={this.props.membershipUsers.some(user => user.isMembershipOwner === true)} email={this.state.userModel.email} /> : ""}
												<div className="footer">
													{!this.state.isNotManual || this.props.common.emailMessage === "User does not exist. Please create the user." ?
														null
														:
														<div className="form-group">
															<button
																type="submit"
																className="btn btnPrimary admin-k-button"
																onClick={this.handleSubmit}
																disabled={!this.state.canInvite}
															>
																<i className="fas fa-paper-plane"></i>
																<span>Send Invite</span>
															</button>
															<button className="btn btn-cancel btnSecondary admin-k-button authorizedUsrCancelBtn" onClick={this.toggleModal}>
																<i className="fas fa-times"></i>
																<span>CANCEL</span>
															</button>
														</div>
													}
												</div>
											</div>
										</Form>
									:
									''
								}
								<div className="table-responsive">
									<h1 className="pt-3 pb-3">Authorized Users</h1>
									<Table hover className="edit-account-form card">
										<thead>
											<tr>
												<th>#</th>
												<th>Member #</th>
												<th>First Name</th>
												<th>Last Name</th>
												<th>Email</th>
												<th>Address</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											{this.props.membershipUsers.length > 0 ? this.props.membershipUsers.map((item, i) =>
												<tr>
													<th scope="row">{item.isPendingInvitation ? "Pending" : [i + 1]}</th>
													<td>{item.memberNumber}</td>
													<td>{item.firstName}</td>
													<td>{item.lastName}</td>
													<td>{item.userName} </td>
													<td>{item.address1}</td>
													{
														!this.state.hideAuthBtns ?
															<td>{item.userId == null && this.state.membershipInEdit.isMembershipOwner ? <label onClick={() => this.editUser(item.memberNumber,)} style={{ color: "blue", cursor: "pointer" }}>Click to Invite</label> : ""}</td>
														: ''
													}
													{(!this.state.hideAuthBtns && this.state.membershipInEdit.isMembershipOwner) ?
														(item.isActive) ?
															<td><Button
																color="primary"
																size="sm"
																className="btnPrimary"
																onClick={() => this.Delete(item)}
															>
																REMOVE
										</Button></td>
															: <td></td>
														: ""}

													{(this.state.membershipInEdit.isMembershipOwner) && (!item.isActive) ?
														<td>

															<p style={{ whiteSpace: "nowrap", color: "red" }}>{this.state.membershipCountMessage}</p>
														</td>
														: ""}
												</tr>
											) : ""}
										</tbody>
									</Table>
								</div>
							</div>
							: <EditMembershipUserForm
								membershipUserInEdit={this.state.membershipUserInEdit}
								cancel={this.returnFromEdit}
								membershipId={this.state.membershipId}
								completeUpdatedInvite={this.completeUpdatedInvite}
								ownerExists = {this.props.membershipUsers.some(user => user.isMembershipOwner === true)}
								/>}
				</div>
				
			</div>
			</React.Fragment>
		);
	}
}

function mapStateToProps(state) {
	return {
		membershipUsers: state.memberInvitation.membershipUsers,
		common: state.common
	};
}

export default withRouter(connect(mapStateToProps, {
	inviteMember, inviteMemberOnEdit,getMembershipUsers,toastr,DeleteMembershipUser,InviteManualUser,RemoveEmailMessage
})(AdditionalMembershipsForm));
